/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserCookieInfoModel } from '../../models/user-cookie-info-model';

export interface EntraExternalDCookieUserInfoGet$Params {
}

export function entraExternalDCookieUserInfoGet(http: HttpClient, rootUrl: string, params?: EntraExternalDCookieUserInfoGet$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<UserCookieInfoModel>> {
  const rb = new RequestBuilder(rootUrl, entraExternalDCookieUserInfoGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<UserCookieInfoModel>;
    })
  );
}

entraExternalDCookieUserInfoGet.PATH = '/EntraExternalD/CookieUserInfo';
